import gql from 'graphql-tag';

const CROP_VARIETY_IDENTIFIER = gql`
  query Query {
    cropVarietyIdentifiers {
      varietyIdentifier
    }
  }
`;

export default CROP_VARIETY_IDENTIFIER;
